import { IApplicationDefinition } from '@apps-config/app-definition';
import { History } from 'history';
import { TReducers } from '@telstra-connect/channel-care/reducers';
import { LoginState } from './sign-in';
import {IFeatureFlagWithBVT} from "@utils/bvt-utils";

type TGetSessionDetails = () => { sessionId: string; };
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type TLiveChatObject = {
    openLiveChat: (user: LoginState.IUserState) => void;
    removeLiveChat: () => void
}
interface IApplications {
    [IncidentManagment: string]: {};
    'Channel Care': {
        CCDIntEnquiry: boolean;
        CCDFileAttachment: boolean;
        application: boolean;
        customerSupportRebuildPhaseTwo: boolean;
        SupportEnquiriesIntUnifiedTrack: boolean;
        CCDIntSupportUnifiedList: boolean;
        showNewcompanyDropdown: boolean;
        ShowNpsFeedbackFromPlatformGlobalExpose: IFeatureFlagWithBVT;
        tedig3350AccessibilityUpliftedCaseDetailsPage: boolean;
        tedig3349BanAndSearchAndListPageUplift: boolean;
        TEDIG3343TransactionalNps: boolean;
        TEDIG7717SingleInvoiceView: boolean;
        tnow_enquiries_enabled_ted3175: IFeatureFlagWithBVT;
    };
    Platform: {
        sideMenu: boolean;
        channelCareDirect: boolean;
        redesignDataRichTiles: boolean;
        redesignTilesPhase2: boolean;
        userProfileApplication: boolean;
        userProfileLoadCompanies: boolean;
        staffDashboardCustomerSearch: boolean;
        welcome: boolean;
        faq: boolean;
        termsandconditions: boolean;
        userManagementBanner: boolean;
        userManagementApplicationLocations: boolean;
        deepLinking: boolean;
        userListPage: boolean;
        dynamicServiceManagement: boolean;
        extendSession: boolean;
        termsAndConditionsAgreement: boolean;
    };
    'Planned Maintenance': {
        application: boolean;
        applicationInternational: boolean;
        displayName: boolean;
        plannedMaintenanceBanner: boolean;
        createEvent: boolean;
        editEvent: boolean;
        withdrawEvent: boolean;
        customerFilter: boolean;
        pmUnifiedTrackerInt: boolean;
        pmSearchBarInt: boolean;
        pmAllCompanySelect: boolean;
    }
}

type IAlertTextSelect = 'displayOfInvoicesAlert' | 'downloadInvoicePdfAlert' | 'customProdIssueAlert';
export enum TransactionType {
    TRACKING_SERVICE = 'TRACKING_SERVICE',
    RAISING_SUPPORT_ENQUIRY = 'RAISING_SUPPORT_ENQUIRY',
    SUBMITTING_A_REQUEST = 'SUBMITTING_A_REQUEST',
    CANCELLING_SUPPORT_ENQUIRY = 'CANCELLING_SUPPORT_ENQUIRY'
}

declare const global: {
    TCONN: {
        getAppRoutingHistory: () => History,
        getSessionDetails: TGetSessionDetails,
        attachApplication:
        (ApplicationName: string, Application: IApplicationDefinition, Reducers: TReducers) => void;
        Platform: {
            liveChat: TLiveChatObject;
            isSecureAuth: boolean;
            showPNpsFeedbackModal: () => void;
            showTNPSModal: (transactionType: TransactionType) => void;
            resolveTargetURL: (targetURL: string) => string;
        },
        ChannelCare: {
            GetApplication: () => IApplicationDefinition,
            GetReducers: () => TReducers,
        },
    },
    applications: IApplications
}

export default global;
